import React from "react";

export default function DccLogo({ size = "md", withWordmark = true, dark = false }) {
  const boxSize = size === "xs" ? "w-4 h-4 text-[9px]" : size === "sm" ? "w-6 h-6 text-xs" : size === "lg" ? "w-10 h-10 text-lg" : "w-8 h-8 text-sm";
  const wm = size === "xs" ? "text-[8px]" : size === "sm" ? "text-[10px]" : size === "lg" ? "text-sm" : "text-[11px]";
  // Dark variant swaps the "DEBT CAPITAL" wordmark to white so it stays readable
  // on the navy sidebar. "COLLEGE" stays orange for brand contrast.
  const wmPrimary = dark ? "text-white" : "text-[#0B0B0B]";
  return (
    <div className="flex items-center gap-3" data-testid="dcc-logo">
      <div className="flex items-center gap-1 font-mono">
        <span className={`${boxSize} inline-flex items-center justify-center bg-white border-2 border-[#F26A21] text-[#0B0B0B] font-black rounded-lg`}>D</span>
        <span className={`${boxSize} inline-flex items-center justify-center bg-[#111111] text-white font-black rounded-lg`}>C</span>
        <span className={`${boxSize} inline-flex items-center justify-center bg-[#F26A21] text-white font-black rounded-lg`}>C</span>
      </div>
      {withWordmark && (
        <div className="flex flex-col leading-tight tracking-[0.08em]">
          <span className={`${wm} font-bold ${wmPrimary}`}>DEBT CAPITAL</span>
          <span className={`${wm} font-bold text-[#F26A21]`}>COLLEGE</span>
        </div>
      )}
    </div>
  );
}
